import {Icon} from '@/components/atoms'
import {COLOR_CODE} from '@/utils/constants/colors'
import {Menu, MenuItem} from '@mui/material'
import {Button} from 'pepsico-ds'
import PropTypes from 'prop-types'
import {useState} from 'react'
import './DataTableToolbar.scss'

const ActionMenu = ({
  actionItems,
  selectedRowsCount,
  onActionClick,
  COLOR_CODE,
}) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)
  const handleMenuClick = event => {
    setAnchorEl(event.currentTarget)
  }
  const handleMenuClose = () => {
    setAnchorEl(null)
  }
  return (
    <div>
      <Button
        onClick={handleMenuClick}
        variant="outlined"
        size="small"
        iconTrailing={<Icon icon="expand_more" size="small" color={COLOR_CODE._3387DF} />}
        className="datatable-toolbar__action-menu-btn"
      >
        Actions
      </Button>
      {actionItems?.length > 0 && (
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleMenuClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          slotProps={{ paper: { className: 'datatable-toolbar__menu-paper' } }}
        >
          {actionItems?.map((action, index) => {
            return (
              <MenuItem
                key={action.id || `action-${index}`}
                onClick={() => onActionClick(action)}
                disabled={action.displayText == 'Download' && selectedRowsCount === 0}
                className="datatable-toolbar__menu-item"
              >
                {action.icon && <Icon icon={action.icon} size="primary" color={COLOR_CODE._FFFFFF} />}
                {action.displayText || action.label}
              </MenuItem>
            )
          })}
        </Menu>
      )}
    </div>
  )
}

const DataTableToolbar = ({
  onResetAll,
  toolbarActions = [],
  selectedRowsCount = 0,
  showActionMenu,
  actionItems,
  onActionClick,
  hideResetButton = false,
}) => {

  return (
    <div className="datatable-toolbar">
      <div className="datatable-toolbar__left">
        {!hideResetButton && (
          <Button className="datatable-toolbar__reset" variant="text" color="primary" size="medium" onClick={onResetAll}>
            Reset All
          </Button>
        )}
      </div>
      <div className="datatable-toolbar__actions">
        {toolbarActions.map((action, index) => (
          <Button
            key={`toolbar-action-${index + 1}`}
            className={`datatable-toolbar__${action.id || action.label.toLowerCase().replace(/\s+/g, '-')}`}
            variant={action.variant || 'outlined'}
            color={action.color || 'primary'}
            size={action.size || 'medium'}
            onClick={action.onClick}
            disabled={action.requiresSelection ? selectedRowsCount === 0 : action.disabled}
            iconLeading={action.icon}
          >
            {action.label}
          </Button>
        ))}
      </div>
      {showActionMenu && (
        <ActionMenu
          actionItems={actionItems}
          selectedRowsCount={selectedRowsCount}
          onActionClick={onActionClick}
          COLOR_CODE={COLOR_CODE}
        />
      )}
    </div>
  )
}

DataTableToolbar.propTypes = {
  onResetAll: PropTypes.func.isRequired,
  hideResetButton: PropTypes.bool,
  toolbarActions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
      icon: PropTypes.node, // Accept ReactNode (string, element, etc)
      variant: PropTypes.string,
      color: PropTypes.string,
      size: PropTypes.string,
      disabled: PropTypes.bool,
      requiresSelection: PropTypes.bool,
    })
  ),
  selectedRowsCount: PropTypes.number,
}

export default DataTableToolbar
